import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export function TrashLiner24(_ref) {
  let {
    size = 24
  } = _ref;
  return /*#__PURE__*/_jsx("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M9.3999 2.26001H14.6899M11.9999 9.60001V18.64M15.3099 9.60001V18.64M8.6899 9.60001V18.64M5.3899 6.25001V20.45C5.3899 21.16 5.9799 21.74 6.7099 21.74H17.2899C18.0199 21.74 18.6099 21.16 18.6099 20.45V6.25001M4.0599 6.25001H19.9399C20.3099 6.25001 20.5999 5.96001 20.5999 5.60001V4.31001C20.5999 3.95001 20.2999 3.66001 19.9399 3.66001H4.0599C3.6899 3.66001 3.3999 3.95001 3.3999 4.31001V5.60001C3.3999 5.96001 3.6999 6.25001 4.0599 6.25001Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round"
    })
  });
}